import { Outlet } from "react-router-dom";

import { getBreadcrumbsBackUrl } from "components/Breadcrumbs/helpers";
import useBreadcrumbs from "components/Breadcrumbs/useBreadcrumbs";
import SubSidebar from "components/SubSidebar";
import SubSidebarSection from "components/SubSidebar/Section";
import SubSidebarSectionItem from "components/SubSidebar/SectionItem";
import SubSidebarSectionTitle from "components/SubSidebar/SectionTitle";
import ViewHeader from "components/ViewHeader";
import ViewHeaderTitle from "components/ViewHeader/Title";
import ViewHeaderWrapper from "components/ViewHeader/Wrapper";
import Box from "ds/components/Box";
import useTitle from "hooks/useTitle";
import useTypedContext from "hooks/useTypedContext";
import useTypedFlags from "hooks/useTypedFlags";

import { FILTERS_ORDER_SETTINGS_KEY } from "../../../Modules/constants";
import { ModuleSettingsContext } from "../../Context";
import styles from "./styles.module.css";

const ModuleSettingsRouteLayout = () => {
  const { sharingModulesBetweenSpaces } = useTypedFlags();
  const { module, canManageModule } = useTypedContext(ModuleSettingsContext);

  useTitle(module?.name ? `Settings · ${module.name}` : "Settings");

  useBreadcrumbs(
    [
      {
        title: "Modules",
        link: getBreadcrumbsBackUrl("/modules", FILTERS_ORDER_SETTINGS_KEY),
      },
      {
        title: module?.name || "",
        link: `/module/${module?.id}`,
      },
      {
        title: "Module settings",
      },
    ],
    [module?.name, module?.id]
  );

  return (
    <>
      <ViewHeader>
        <ViewHeaderWrapper align="center" fullWidth>
          <ViewHeaderTitle>Module settings</ViewHeaderTitle>
        </ViewHeaderWrapper>
      </ViewHeader>
      <Box grow="1">
        <SubSidebar>
          <SubSidebarSection>
            <SubSidebarSectionItem to=".." end>
              Module details
            </SubSidebarSectionItem>
            <SubSidebarSectionItem to="../source-code">Source code</SubSidebarSectionItem>
            <SubSidebarSectionItem to="../behavior">Behavior</SubSidebarSectionItem>
            <SubSidebarSectionItem to="../integrations">Integrations</SubSidebarSectionItem>
            {sharingModulesBetweenSpaces && (
              <SubSidebarSectionItem to="../availability">Availability</SubSidebarSectionItem>
            )}

            <SubSidebarSectionItem to="../sharing">Sharing</SubSidebarSectionItem>
          </SubSidebarSection>

          {canManageModule.result && (
            <SubSidebarSection>
              <SubSidebarSectionTitle>Danger area</SubSidebarSectionTitle>
              <SubSidebarSectionItem to="../deletion">Module deletion</SubSidebarSectionItem>
            </SubSidebarSection>
          )}
        </SubSidebar>

        <Box direction="column" className={styles.wrapper}>
          <Outlet />
        </Box>
      </Box>
    </>
  );
};

export default ModuleSettingsRouteLayout;
